import React from "react";
import Modal from "../../../../components/elements/Modal";
import ManageQuestion from "../ManageQuestion";

const ManageQuestionModal = ({ open, close = () => {}, getResponse = () => {}, data = {} }) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="lg" title={"Create New "}>
      <ManageQuestion getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageQuestionModal;
